"use client";

import React from "react";
import PropTypes from "prop-types";
import SearchBar from "./SearchBar";
import styles from "../css/components/filterSearch.module.css";

export default function FilterSearch({
  filterName,
  value,
  onChange,
  placeholder,
  wrapperStyle,
  labelStyle,
  searchContainerStyle,
  searchInputStyle,
  wrapperClassName,
  labelClassName,
  searchContainerClassName,
  searchInputClassName,
  iconSize,
  iconColor,
}) {
  return (
    <div
      className={[styles.filterSearchContainer, wrapperClassName].filter(Boolean).join(" ")}
      style={wrapperStyle}
    >
      <span className={[styles.filterName, labelClassName].filter(Boolean).join(" ")} style={labelStyle}>
        {filterName}
      </span>
      <SearchBar
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        containerStyle={searchContainerStyle}
        inputStyle={searchInputStyle}
        containerClassName={searchContainerClassName}
        inputClassName={searchInputClassName}
        iconSize={iconSize}
        iconColor={iconColor}
      />
    </div>
  );
}

FilterSearch.propTypes = {
  filterName: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  wrapperStyle: PropTypes.object,
  labelStyle: PropTypes.object,
  searchContainerStyle: PropTypes.object,
  searchInputStyle: PropTypes.object,
  wrapperClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  searchContainerClassName: PropTypes.string,
  searchInputClassName: PropTypes.string,
  iconSize: PropTypes.number,
  iconColor: PropTypes.string,
};